import { Message, MessageBox } from 'element-ui'
import type { ElMessageComponent } from 'element-ui/types/message'
import i18n from '@/lang'

export function showNetworkExceptionMessage(): ElMessageComponent {
  return Message.error({
    message: i18n.t('playTurbo.common.network.networkException').toString(),
    duration: 0,
    showClose: true,
  })
}

export function showInternationalMessage(): ReturnType<
  typeof MessageBox.confirm
> {
  return MessageBox.confirm(
    i18n.t('playTurbo.permission.tips.areaNoPermission').toString(),
    i18n.t('playTurbo.permission.useless').toString(),
    {
      confirmButtonText: i18n.t('playTurbo.whole.gotit').toString(),
      showCancelButton: false,
      type: 'warning',
      center: true,
      customClass: 'pt-custom-confirm-message pt-no-type-confirm-message',
    },
  )
}

export function showCNMessage(): ElMessageComponent {
  return Message.error({
    message: i18n.t('playTurbo.permission.tips.areaNoPermission').toString(),
    duration: 0,
    showClose: true,
  })
}
